module.exports = __webpack_public_path__ + "static/media/fib.70549b64.jpg";